import { cn } from '@/shadcn/lib/utils';
import { MOTION, LIFT } from './motion';
import { RX_CONTROL_H } from './controls';

/**
 * Pill - segmentovy prepinac v hero (Ponuka / Dopyt / Objav viac) a nav odkazy vedla neho.
 * Toto je vychodiskovy tvar celeho portalu: polopriehladna biela na zltom,
 * aktivny stav je plna biela s mekkym tienom.
 *
 * Vysku berie z RX_CONTROL_H (controls.ts) - rovnaku ako bare fieldy klasickeho
 * filtra a kruhove ikonove tlacidla vedla nich. Nikdy ju nedefinuj lokalne.
 *
 * Solidne tlacidla (Button.tsx) su ina skala (40 / 45 px) - ziju na bielych
 * plochach, nie na zltom hero, a na tento riadok nepatria.
 */
type PillState = 'active' | 'inactive';

interface Props extends React.ComponentProps<'a'> {
    state?: PillState;
}

/** Zdielany tvar pilulky - preberaju ho aj solidne tlacidla. */
export const PILL_SHAPE = cn(
    RX_CONTROL_H,
    'px-[13px] rounded-[30px] text-[12px] font-[500] whitespace-nowrap',
    'sm:text-[13px]',
    'xl:text-[14px]',
);

const PILL_STATES: Record<PillState, string> = {
    // aktivny sa uz nehybe - je vybraty, hover by len rusil
    active: 'bg-[#fff] shadow-[0_11px_27px_0_rgba(0,0,0,0.15)]',
    inactive: cn(
        'bg-[rgba(255,255,255,.5)] text-black/80',
        'duration-[260ms]',
        'hover:bg-white hover:text-black',
        'hover:shadow-[0_11px_27px_0_rgba(0,0,0,0.14)]',
        'hover:-translate-y-[2px] active:translate-y-0 active:scale-[.98]',
    ),
};

export function Pill({ state = 'inactive', className, children, ...props }: Props) {
    return (
        <a
            className={cn(
                PILL_SHAPE,
                // vyska je fixna -> obsah sa centruje flexom, nie paddingom
                'flex items-center justify-center w-full text-center cursor-pointer',
                'lg:w-[auto] lg:min-w-[100px]',
                MOTION,
                PILL_STATES[state],
                className,
            )}
            {...props}
        >
            {children}
        </a>
    );
}
